// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__jBm8Q","toggleInput":"Toggle_toggleInput__IiZhw","toggleLabel":"Toggle_toggleLabel__mljah","labelText":"Toggle_labelText__6lZFg"};